import { Radio } from '@cambridgeassessment/cambridge-ui';
import clsx from 'clsx';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import { useStyles } from './styles';

export type Option = {
  id: string;
  label: string;
};
interface ISelect {
  options: Option[];
  onSelect: (arg0: string) => void;
  selected?: string;
  className?: string;
  'data-testid'?: string;
}
const Select: React.FC<ISelect> = ({
  options,
  onSelect,
  selected,
  className,
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <div {...restProps}>
      {options.map(({ id, label }) => (
        <Radio
          bold
          className={clsx(classes.radio, className)}
          key={id}
          color="primary"
          dataTestId={`select-option-${id}`}
          label={label}
          name={id}
          onChange={() => onSelect(id)}
          checked={id === selected}
        />
      ))}
    </div>
  );
};

export default hot(Select);
